import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";

import getQuoteBanner from "../../../assets/images/happy-couple-car-dealership-banner.7d041973b88880a5f1b6-min.png";
import pidmLogo from "../../../assets/images/insurance/PIDM Logo.png";
import lonpacInsurance from "../../../assets/images/insurance/lonpac-insurance.png";
import etiqaInsurance from "../../../assets/images/insurance/etiqa-insurance.png";
import takafulMalaysia from "../../../assets/images/insurance/takaful-insurance.png";
import chubbInsurance from "../../../assets/images/insurance/chubb-insurance.png";
import allianz from "../../../assets/images/insurance/allianz.png";
import zurichTakaful from "../../../assets/images/insurance/zurich-takaful.png";
import generali from "../../../assets/images/insurance/generali.png";
import tokioMarine from "../../../assets/images/insurance/tokio-marine-insurance.png";
import rhbInsuracne from "../../../assets/images/insurance/rhb-insurance.png";
import berjayaSompo from "../../../assets/images/insurance/berjaya-sompo.png";
import takafulIkhlas from "../../../assets/images/insurance/takaful-ikhlas.png";
import liberty from "../../../assets/images/insurance/liberty-insurance.png";
import tuneInsurance from "../../../assets/images/insurance/tune-protect.png";

// Tune private car, comprehensive. Supplied by Tune via Ansa-Support#39 (2026-08-21),
// superseding the Motor Easy partnership PDS and the Ver8/May2024 policy wording.
import pdsCarTuneProtect from "../../../assets/documents/PDS_TP_PrivateCar_Comprehensive_VerJan26.pdf";
import pwCarTuneProtect from "../../../assets/documents/PW_TP_PrivateCar_ver02-2026.pdf";
import pdsMotorTuneProtect from "../../../assets/documents/PDS_BikeEasy_Pntrship.pdf";
import pwMotorTuneProtect from "../../../assets/documents/PW_BikeEasy.pdf";

import takafulikhlasaqad from "../../../assets/documents/Takaful-Ikhlas-Aqad-Declaration.pdf";
import takafulikhlasPDP from "../../../assets/documents/Takaful-Ikhlas-Personal-Data-Protection-(PDP).pdf";
import takafulikhlasMarketing from "../../../assets/documents/Takaful-Ikhlas-Marketing-Communication.pdf";

import { Image } from "primereact/image";
import { FaCheck, FaFile, FaCircleInfo } from "react-icons/fa6";
import { MdInfoOutline } from "react-icons/md";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import useGetCarAddOnSelection from "../../../store/selectors/get-car-add-on-selection";
import useGetToken from "../../../store/selectors/get-token";
import {
	getProfile,
	//createOrder,
	viewPolicy,
} from "../../../utils/backend";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useStoreOrderDetailsId from "../../../store/actions/store-order-details";
import { getInsurerName } from "../../../utils/insurer-name";
import UnderwriterDisclosure from "../../../components/UnderwriterDisclosure";
import { Acknowledgement } from "../../../components/terms-and-condition/acknowledgement";

/* Tune issues its Product Disclosure Sheet and policy wordings per language, as separate
   files, and does not issue every language. Only the English private-car pair is current
   (supplied by Tune, Ansa-Support#39, 2026-08-21); Tune has issued no Bahasa Malaysia
   version of either, and the motorcycle pair below is still the superseded issue awaiting
   a current one from Tune.

   Adding a language later is one line: drop the file into assets/documents, import it, and
   add it under the right key. We never translate these ourselves - a PDS and a policy
   wording are regulated documents, and an unofficial translation shown to a customer under
   those headings is a compliance and claims problem. */
const TUNE_DOCS = {
	car: {
		pds: { en: pdsCarTuneProtect },
		pw: { en: pwCarTuneProtect },
	},
	motorcycle: {
		/* ⚠ KNOWN STALE - RESTORED BY ANSA DECISION 2026-08-21 (Ansa-Support#39).
		   PDS_BikeEasy_Pntrship.pdf is footer-marked "For Internal Use Only" on all three
		   of its pages and states it is valid as at 8 July 2022. It was withdrawn earlier
		   the same day for exactly that reason, and restored on ANSA's instruction: a motor
		   customer must be shown a Product Disclosure Sheet, and no replacement exists yet.
		   Showing a stale one was judged the lesser problem against showing none.

		   This is a holding position, not a resolved one. Tune has been asked for the
		   current issue cleared for customer distribution; swap it in here the moment it
		   lands and delete this comment.

		   Do NOT substitute Tune's published PDS_ThirdPartyMotorcycle.pdf - that is a
		   different product from the Bike Easy comprehensive plan we sell. */
		pds: { en: pdsMotorTuneProtect },
		pw: { en: pwMotorTuneProtect },
	},
};


const CarDetails = () => {
	const selectedPlan = useGetCarPlan();
	const vehicleInfo = useGetVehicleInfo();
	const token = useGetToken();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState("");
	const [phone_no, setPhoneNo] = useState("");
	const storeOrderDetailsId = useStoreOrderDetailsId();

	const addOnSelection = useGetCarAddOnSelection();
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	
	const [selectedVariant, setSelectedVariant] = useState(() => {
		const cachedVariant = localStorage.getItem("selectedVariant");
		return cachedVariant ? JSON.parse(cachedVariant) : null;
	});

	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const [openCompulsoryExcessModal, setOpenCompulsoryExcessModal] = useState(false);

	const [isAckVisible, setIsAckVisible] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [isProductsVisible, setIsProductsVisible] = useState(false);

	const [checkModal, setCheckModal] = useState(false);
	const [checkAck, setCheckAck] = useState(false);
	const [checkProduct, setCheckProduct] = useState(false);
	const [checkTakaful, setCheckTakaful] = useState(false);
	const [checkTakafulMarketing, setCheckTakafulMarketing] = useState(false);

	const [hasOpenedAck, setHasOpenedAck] = useState(false);
	const [hasOpenedModal, setHasOpenedModal] = useState(false);
	const [hasOpenedProducts, setHasOpenedProducts] = useState(false);

	const [checkConfirmAll, setCheckConfirmAll] = useState(false);
  const checkConfirmAllRef = useRef(null);

	const handleModalCheckboxChange = () => {
		setCheckModal((prev) => !prev); // Toggle checkbox state
		if (!checkModal) {
			if (selectedPlan.insurer_name !== "LONPAC") {
				setIsModalVisible(true);
			}
			setHasOpenedModal(true);
		}
	};
	
	const handleProductCheckboxChange = () => {
		setCheckProduct((prev) => !prev); // Toggle checkbox state
		if (!checkProduct) {
			if (selectedPlan.insurer_name !== "LIBERTY" && selectedPlan.insurer_name !== "ETIQA") {
				setIsProductsVisible(true);
			}

			setHasOpenedProducts(true);
		}
	};
	
	const handleAckCheckboxChange = () => {
		setCheckAck((prev) => !prev); // Toggle checkbox state
		if (!checkAck) {
			if (selectedPlan.insurer_name !== "LIBERTY" && selectedPlan.insurer_name !== "ETIQA" && selectedPlan.insurer_name !== "ALLIANZ") {
				setIsAckVisible(true);
			}
			setHasOpenedAck(true);
		}
	};

	const allModalsOpened = hasOpenedAck && hasOpenedModal && hasOpenedProducts;

	const openFilterModal = () => {
		setIsModalVisible(true);
	};

	const closeFilterModal = () => {
		setIsModalVisible(false);
		setCheckModal(true);
	};

	const openAckModal = () => {
		setIsAckVisible(true);
	};

	const closeAckModal = () => {
		setIsAckVisible(false);
		setCheckAck(true);
	};

	const openProductsModal = () => {
		setIsProductsVisible(true);
	};

	const closeProductsModal = () => {
		setIsProductsVisible(false);
		setCheckProduct(true);
	};

	useEffect(() => {
		console.log('vehicleInfo', vehicleInfo)
	}, [vehicleInfo])

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);

		if (!match) {
			throw new Error("Invalid ID number format");
		}

		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);

		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);

		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;

		let fullYear;

		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
			fullYear = `20${yearPrefix}`;
		} else {
			fullYear = `19${yearPrefix}`;
		}

		const dob = new Date(`${fullYear}-${month}-${day}`);

		const age = currentYear - dob.getFullYear();

		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error("Invalid birth year in ID number");
		}

		const gender = genderDigit % 2 === 0 ? "F" : "M";

		const formattedDob = dob.toISOString().split("T")[0];

		return {
			dob: formattedDob,
			gender: gender,
			age: age,
		};
	};

	const { i18n } = useTranslation();

	/** Tune's document for this vehicle type in the reader's language, falling back to
	 *  the English issue when Tune has not issued that language. */
	const tuneDoc = (vehType, kind) => {
		const byLang = TUNE_DOCS[vehType]?.[kind];

		if (!byLang) return undefined;

		return byLang[(i18n?.language || "en").slice(0, 2)] || byLang.en;
	};

	// Generate the PDS link based on vehicle info
	const getPDSLink = () => {
		if (vehicleInfo?.insurer_name === "RHBI" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_RHBI_PRIVATE_CAR_PDS;
		} else if (vehicleInfo?.insurer_name === "RHBI" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_RHBI_MOTORCYCLE_PDS;
		} else if (vehicleInfo?.insurer_name === "TOKIO MARINE" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_TOKIO_MARINE_PRIVATE_CAR_PDS;
		} else if (vehicleInfo?.insurer_name === "TOKIO MARINE" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_TOKIO_MARINE_MOTORCYCLE_PDS;
		} else if (vehicleInfo?.insurer_name === "GENERALI" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_GENERALI_PRIVATE_CAR_PDS;
		} else if (vehicleInfo?.insurer_name === "GENERALI" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_GENERALI_MOTORCYCLE_PDS;
		} else if (vehicleInfo?.insurer_name === "LIBERTY" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_LIBERTY_PRIVATE_CAR_PDS;
		} else if (vehicleInfo?.insurer_name === "LIBERTY" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_LIBERTY_MOTORCYCLE_PDS;
		} else if (vehicleInfo?.insurer_name === "BERJAYA SOMPO" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_SOMPO_PRIVATE_CAR_PDS;
		} else if (vehicleInfo?.insurer_name === "BERJAYA SOMPO" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_SOMPO_MOTORCYCLE_PDS;
		} else if (
			vehicleInfo?.insurer_name === "LONPAC"
		) {
			return process.env.REACT_APP_LONPAC_PDS;
		} else if (
			vehicleInfo?.insurer_name === "ETIQA" &&
			vehicleInfo?.veh_type === "car"
		) {
			return process.env.REACT_APP_ETIQA_PRIVATE_CAR_PDS;
		} else if (
			vehicleInfo?.insurer_name === "ETIQA" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return process.env.REACT_APP_ETIQA_MOTORCYCLE_PDS;
		} else if (
			vehicleInfo?.insurer_name === "ALLIANZ" &&
			vehicleInfo?.veh_type === "car"
		) {
			return process.env.REACT_APP_ALLIANZ_PRIVATE_CAR_PDS;
		} else if (
			vehicleInfo?.insurer_name === "ALLIANZ" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return process.env.REACT_APP_ALLIANZ_MOTORCYCLE_PDS;
		} else if (
			vehicleInfo?.insurer_name === "TAKAFUL IKHLAS" &&
			vehicleInfo?.veh_type === "car"
		) {
			return process.env.REACT_APP_TAKAFUL_IKHLAS_PRIVATE_CAR_PDS;
		} else if (
			vehicleInfo?.insurer_name === "TAKAFUL IKHLAS" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return process.env.REACT_APP_TAKAFUL_IKHLAS_MOTORCYCLE_PDS;
		} else if (
			vehicleInfo?.insurer_name === "TUNE PROTECT" &&
			vehicleInfo?.veh_type === "car"
		) {
			return tuneDoc("car", "pds");
		} else if (
			vehicleInfo?.insurer_name === "TUNE PROTECT" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return tuneDoc("motorcycle", "pds");
		} else {
			return selectedPlan?.product_disclosure_sheet || "#";
		}
		return ""; // Fallback if no condition matches
	};

	const getPWLink = () => {
		if (vehicleInfo?.insurer_name === "RHBI" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_RHBI_PRIVATE_CAR_PW;
		} else if (vehicleInfo?.insurer_name === "RHBI" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_RHBI_MOTORCYCLE_PW;
		} else if (vehicleInfo?.insurer_name === "TOKIO MARINE" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_TOKIO_MARINE_PRIVATE_CAR_PW;
		} else if (vehicleInfo?.insurer_name === "TOKIO MARINE" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_TOKIO_MARINE_MOTORCYCLE_PW;
		} else if (vehicleInfo?.insurer_name === "GENERALI" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_GENERALI_PRIVATE_CAR_PW;
		} else if (vehicleInfo?.insurer_name === "GENERALI" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_GENERALI_MOTORCYCLE_PW;
		} else if (vehicleInfo?.insurer_name === "LIBERTY" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_LIBERTY_PRIVATE_CAR_PW;
		} else if (vehicleInfo?.insurer_name === "LIBERTY" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_LIBERTY_MOTORCYCLE_PW;
		} else if (vehicleInfo?.insurer_name === "BERJAYA SOMPO" && vehicleInfo?.veh_type === "car") {
			return process.env.REACT_APP_SOMPO_PRIVATE_CAR_PW;
		} else if (vehicleInfo?.insurer_name === "BERJAYA SOMPO" && vehicleInfo?.veh_type === "motorcycle") {
			return process.env.REACT_APP_SOMPO_MOTORCYCLE_PW;
		} else if (
			vehicleInfo?.insurer_name === "LONPAC"
		) {
			return process.env.REACT_APP_LONPAC_PW;
		} else if (
			vehicleInfo?.insurer_name === "ETIQA" &&
			vehicleInfo?.veh_type === "car"
		) {
			return process.env.REACT_APP_ETIQA_PRIVATE_CAR_PW;
		} else if (
			vehicleInfo?.insurer_name === "ETIQA" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return process.env.REACT_APP_ETIQA_MOTORCYCLE_PW;
		} else if (
			vehicleInfo?.insurer_name === "ALLIANZ" &&
			vehicleInfo?.veh_type === "car"
		) {
			return process.env.REACT_APP_ALLIANZ_PRIVATE_CAR_PW;
		} else if (
			vehicleInfo?.insurer_name === "ALLIANZ" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return process.env.REACT_APP_ALLIANZ_MOTORCYCLE_PW;
		} else if (
			vehicleInfo?.insurer_name === "TAKAFUL IKHLAS" &&
			vehicleInfo?.veh_type === "car"
		) {
			return process.env.REACT_APP_TAKAFUL_IKHLAS_PRIVATE_CAR_PW;
		} else if (
			vehicleInfo?.insurer_name === "TAKAFUL IKHLAS" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return process.env.REACT_APP_TAKAFUL_IKHLAS_MOTORCYCLE_PW;
		} else if (
			vehicleInfo?.insurer_name === "TUNE PROTECT" &&
			vehicleInfo?.veh_type === "car"
		) {
			return tuneDoc("car", "pw");
		} else if (
			vehicleInfo?.insurer_name === "TUNE PROTECT" &&
			vehicleInfo?.veh_type === "motorcycle"
		) {
			return tuneDoc("motorcycle", "pw");
		} else {
			return selectedPlan?.policy_wording || "#";
		}
		return "";
	};


	const submitCarDetails = async (e) => {
		e.preventDefault();

		if (!allModalsOpened) {
			showErrorMessage("Please review all agreements before proceeding.");
			return;
		  }

		if (!checkConfirmAll) {
			showErrorMessage("Please confirm all the fields before proceeding.");
			return;
		}


		setLoading(true);
		try {
			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");
			navigate(policyId ? `/get-quote/payment-page?policy_id=${policyId}` : `/get-quote/payment-page`);
		} catch (error) {
			setLoading(false);
			showErrorMessage("Something went wrong. Please Try Again.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [getProfile]);

	const fetchData = async () => {
		if (token) {
			const response = await getProfile(token);
			if (response.success) {
				if (response.data.email) {
					setEmail(response?.data?.email);
				}
				if (response.data.phone_number) {
					setPhoneNo(response?.data?.phone_number);
				}
			}
		}
	};

	const getAddOnDescription = (code) => {
		// Get the stored add-ons from localStorage
		let storedAddOns;
		let selectedAddOn;
		if (selectedPlan?.insurer_name == "TOKIO MARINE") {
			storedAddOns = JSON.parse(localStorage.getItem("tmim_add_ons")) || [];

			const matched = storedAddOns.find(addOn => addOn.code === code);
			return matched?.description || matched?.code;
		} else {
			selectedAddOn =
				JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
			storedAddOns = selectedAddOn.map((addon) => ({
				add_on_code: addon.code || "",
				add_on_name: addon.title || "",
				add_on_description: addon.description || "",
			}));
		}

		// Find the add-on with the matching code
		const matched = storedAddOns.find(addOn => addOn.add_on_code.trim() === code.trim());
	  
		// Return the description if found, otherwise return the code
		return matched?.add_on_name || matched?.add_on_description;
	};
	  
	// console.log("PDS Link:", getPDSLink());
	// console.log("PW Link:", getPWLink());

	function formatDate(dateStr) {
		if (!dateStr) return "";
		const date = new Date(dateStr);
		  
		if (isNaN(date)) return ""; // handle invalid date
		  
		const day = String(date.getDate()).padStart(2, "0");
	  
		const months = [
			"JAN", 
			"FEB", 
			"MAR", 
			"APR", 
			"MAY", 
			"JUN", 
			"JUL", 
			"AUG", 
			"SEP", 
			"OCT", 
			"NOV", 
			"DEC"
		];
		
		const month = months[date.getMonth()];
		const year = date.getFullYear();
	  
		return `${day}-${month}-${year}`;
	}

	return (
		<>
			<div className="content">
				<div className="get-quote-process-container">
					<div className="d-flex w-100">
						<h3>Your vehicle details</h3>
						<div className="car-details-block border-radius-25 p-20">
							<div className="grid">
								<div className="col-lg-6 text-left px-20">
									<h4 className="my-2 mt-4">
										{vehicleInfo?.id_type === "business" ? "Company's Info" : "Owner’s Info"}
									</h4>
									<hr style={{ border: '1px solid #ccc', backgroundColor: '#ccc' }} />

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">
												{vehicleInfo?.id_type === "business" ? "Company Name" : "Name"}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{vehicleInfo?.id_type === "business" ? vehicleInfo?.companyName : vehicleInfo?.owner_name}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">
												{vehicleInfo?.id_type === "business"
													? "Business Reg Number"
													: vehicleInfo?.id_type === "passport"
													? "Passport Number"
													: "ID Number"
												}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{vehicleInfo?.id_no}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="w-50text-left">
											<span className="formatted-text">
												{"Next Coverage Period"}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{`${
													formatDate(vehicleInfo?.effective_date)
												} - ${
													formatDate(vehicleInfo?.expiry_date)
												}`}
											</span>
										</div>
									</div>
								</div>
								<div className="col-lg-6 text-left px-20">
									<h4>Vehicle Details</h4>
									<hr
										style={{
											border: "1px solid #ccc",
											backgroundColor: "#ccc",
										}}
									/>
									<div className="d-flex justify-content-between align-items-start pb-2">
										<div className="vw-50 col-sm-6 text-left">
											<span className="formatted-text">{"Vehicle Model"}</span>
										</div>
										<div className="vw-50 col-sm-6 text-right">
											<span className="fw-medium color-heading">
												{vehicleInfo?.vehicle}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-start pb-2">
										<div className="vw-50 col-sm-6 text-left">
											<span className="formatted-text">{"Variant"}</span>
										</div>
										<div className="vw-50 col-sm-6 text-right">
											<span className="fw-medium color-heading">
												{`${selectedVariant?.variant_name} ${selectedVariant?.variant_transmission} (${selectedVariant?.variant_capacity}cc)`}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">
												{"Year of Manufacture"}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{vehicleInfo?.make_year}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">
												{"Registration No."}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{vehicleInfo?.reg_no}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">
												{`Sum Covered/Sum Insured ${
													selectedPlan?.insurer_name === "LONPAC"
													? "(Agreed Value)"
													: selectedPlan?.agree_value
													? "(Agreed Value)"
													: "(Market Value)"
												}:`}
											</span>
										</div>
										<div className="vw-50 text-right">
											{selectedPlan?.sum_insured && (
												<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
													"en-US",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}
												).format(selectedPlan?.sum_insured || 0)}`}</span>
											)}
										</div>
									</div>
								</div>

								<p className="formatted-text px-20">
									{
										vehicleInfo?.insurer_name === "LONPAC" 
										? "Note: The agreed value is determined directly by the takaful/insurance company based on the vehicle details provided"
										: "Note: The market value is determined directly by the takaful/insurance company based on the vehicle details provided"
									}
								</p>

								<div className="col-lg-6 text-left px-20">
									<h4 className="my-2 mt-4">{vehicleInfo?.insurer_name === "ETIQA" ? `Product Underwritten By` : `Takaful/Insurance Package Underwritten By`}</h4>
									<hr
										style={{
											border: "1px solid #ccc",
											backgroundColor: "#ccc",
										}}
									/>
									<div className="w-100">
										{selectedPlan && (
											<Image
												width="100%" 
												height="auto" 
												src={selectedPlan.image_url}
												alt={selectedPlan.provider}
												style={{
													maxWidth: [
														"GENERALI",
														"BERJAYA SOMPO",
														"TAKAFUL IKHLAS",
														"TOKIO MARINE",
														"TUNE PROTECT",
													].includes(selectedPlan.insurer_name)
														? "100px"
														: "150px",
													height: "auto",
													display: "block",
													margin: "0"
												}}
											/>
										)}

										{/* TIMB NDDP item 1 (Ansa-Support#30): the insurer mark alone is not
											sufficient under this heading — the underwriter's registered legal
											name, company number and the distributor relationship have to be
											read with it. */}
										{selectedPlan?.insurer_name === "TUNE PROTECT" && (
											<UnderwriterDisclosure
												insurerName={selectedPlan.insurer_name}
												className="pt-2"
											/>
										)}

										<div>
											<p className="fw-medium">{`Total Coverage - RM ${new Intl.NumberFormat(
												"en-US",
												{
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}
											).format(selectedPlan?.sum_insured || 0)}`}</p>
										</div>

										<div className="d-flex flex-row gap-2 pb-2">
											{/* No tile at all when we hold no PDS for this insurer and vehicle
											    type - a dead "Product Disclosure Sheet" link is worse than none.
											    Currently that is Tune motorcycle only (Ansa-Support#39). */}
											{getPDSLink() ? (
												<div className="d-flex gap-2 bg-light-primary border-radius-5 p-10">
													<FaFile className="primary" />{" "}
													<a
														href={getPDSLink()}
														target="_blank"
														rel="noopener noreferrer"
														className="color-primary text-decoration-none"
													>
														Product Disclosure Sheet
													</a>
												</div>
											) : null}
											<div className="d-flex gap-2 bg-light-primary border-radius-5 p-10">
												<FaFile className="primary" />{" "}
												<a
													href={getPWLink()}
													target="_blank"
													rel="noopener noreferrer"
													className="color-primary text-decoration-none"
												>
													Certificate/Policy Wording
												</a>
											</div>
										</div>

										<div>
											<div className="pb-2">
												<span>{"What’s included in your package?"}</span>
											</div>
											{(selectedPlan?.insurer_name === "TUNE PROTECT" && vehicleInfo?.veh_type === "car") ? (
												<>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Free 6-month guarantee on workmanship and replacement parts at authorised panel workshops"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"24-hour emergency auto assistance"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"More than 300 authorised car workshops across Malaysia"}</span>
												</div>
												</>
											) 
											:
											(selectedPlan?.insurer_name === "TUNE PROTECT" && vehicleInfo?.veh_type === "motorcycle") ? (
												<>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Liabilities to third party for injury, death and property loss or damage"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Loss or damage to own vehicle due to accident, fire or theft"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Loss or damage to own vehicle due to accident"}</span>
												</div>
												</>
											)
											:
											selectedPlan?.insurer_name === "LONPAC" ? (
												<>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Loss/Damage to vehicle due to accidental collision or overturning, fire and theft"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"24/7 Emergency Roadside & Breakdown Assistance With Lonpac Road Assist"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"All Drivers cover with no additional premium"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Transportation & Document Allowance up to RM150"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Impact Damage by falling tress due to convulsions of nature"}</span>
												</div>
												</>
											)
											:
											selectedPlan?.insurer_name === "TAKAFUL IKHLAS" ? (
												<>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Loss or damage to your vehicle due to accident, fire & theft"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Third-party death & bodily injury"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Third-party property damage"}</span>
												</div>
												<div className="pb-2">
													<FaCheck className="dark" />
													{"  "}
													<span>{"Complimentary Bantuan IKHLAS Road Assist Service"}</span>
												</div>
												</>
											)
											:
											(
											<>
											<div className="pb-2">
												<FaCheck className="dark" />
												{"  "}
												<span>{"Covers all necessities for your vehicle"}</span>
											</div>
											<div className="pb-2">
												<FaCheck className="dark" />
												{"  "}
												<span>
													{
														"Own Damage"
													}
												</span>
											</div>
											<div className="pb-2">
												<FaCheck className="dark" />
												{"  "}
												<span>
													{
														vehicleInfo?.insurer_name === "GENERALI" ? "Third Party Bodily Injury or Death" : "Third Party Bodily Injury & Death"
													}
												</span>
											</div>
											<div className="pb-2">
												<FaCheck className="dark" />
												{"  "}
												<span>
													{
														vehicleInfo?.insurer_name === "GENERALI" ? "Third Party Property Loss or Damage" : "Third Party Property Loss & Damage"
													}
												</span>
											</div>
											</>
											)}
										</div>

										<p className="formatted-text">
											{"* subject to certificate/policy's terms & conditions"}
										</p>

										<p className="formatted-text">
											{vehicleInfo?.insurer_name === "BERJAYA SOMPO"
												? `Berjaya Sompo Insurance is a member of PIDM. The benefit(s) payable under eligible certificate/policy is protected by PIDM up to limits. Please refer to PIDM's `
												: vehicleInfo?.insurer_name === "LIBERTY"
												? `Liberty General Insurance Berhad is a member of PIDM. PIDM protects the benefit(s) payable under the eligible certificate/policy up to protection limits. Please refer to PIDM's `
												: vehicleInfo?.insurer_name === "LONPAC"
												? `The benefit(s) payable under eligible certificate/policy is protected by PIDM up to limits. Please refer to the PIDM's `
												: `The benefit(s) payable under this eligible certificate/policy is protected by PIDM up to limits. Please refer to the PIDM's `}
											<Link
												to="https://www.pidm.gov.my/en/how-we-protect-you/tips/information-materials/brochures"
												target="_blank"
												rel="noopener noreferrer"
											>
												TIPS Brochure
											</Link>
											{` or `}

											{vehicleInfo?.insurer_name === "LIBERTY" ? 
												<>
													{`PIDM's `}
													<Link to="https://www.pidm.gov.my/en" target="_blank" rel="noopener noreferrer">
														Website
													</Link>
													{` or contact our customer service.`}
												</>
											:
												`contact ${getInsurerName(
													selectedPlan.insurer_name
												)} or PIDM (visit `
											}
											{vehicleInfo?.insurer_name === "LIBERTY" ? 
												``
												: <Link
													to="https://www.pidm.gov.my/en"
													target="_blank"
													rel="noopener noreferrer"
												>
													www.pidm.gov.my
												</Link>}
											{vehicleInfo?.insurer_name === "LIBERTY" ? 
												``
												: `).`}
										</p>

										{selectedPlan.insurer_name === "LONPAC" && (
											<>
											<p className="formatted-text">
												{`Lonpac Insurance Bhd is licensed under the Financial Services Act 2013 and regulated by Bank Negara Malaysia.`}
											</p>

											<p className="formatted-text">
												{`Some of the services offered on the platform:`}
												<ul>
													<li className="text-justify">{`Get quotes instantly from our panel of insurers`}</li>
													<li className="text-justify">{`Compare plans and benefits`}</li>
													<li className="text-justify">{`Make payment online and get covered`}</li>
													<li className="text-justify">{`Get product information via Product Disclosure Sheet`}</li>

												</ul>
											</p>

											<p className="formatted-text">{`For more information on the purchase and product information, claims matters or complaints, kindly contact us at: `}
												<a href="tel:+60327795998">03-27795998</a>
												{" or "}
												<a href="mailto:contactus@ansa.my">contactus@ansa.my</a>.
											</p>
											</>
										)}

										<img
											src={pidmLogo}
											alt="PIDM"
											style={{ width: "70px", height: "auto" }}
										/>
									</div>
								</div>

								<div className="col-lg-6 text-left px-20">
									<h4 className="my-2 mt-4">Contribution/Premium Details</h4>
									<hr
										style={{
											border: "1px solid #555",
											backgroundColor: "#555",
										}}
									/>

									{selectedPlan?.insurer_name === "TUNE PROTECT" &&
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div className="vw-50 text-left">
												<span className="formatted-text">
													{vehicleInfo?.veh_type === "car" ? 'Tune Motor Easy' : 'Tune Bike Easy'}
												</span>
											</div>
										</div>
									}
									
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">
												{"Protection Type"}
											</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">
												{"Comprehensive"}
											</span>
										</div>
									</div>

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
											<span className="formatted-text">{"Basic Contribution/Premium"}</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
												"en-US",
												{
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}
											).format(selectedPlan?.basic_premium || 0)}`}</span>
										</div>
									</div>

									{Number(selectedPlan?.all_rider_amount) > 0 && (
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div className="vw-50 text-left">
												<span className="formatted-text">
													{
														"All Rider Premium"
													}
												</span>
											</div>
											<div className="vw-50 text-right">
												<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
													"en-US",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}
												).format(
													Number(
														selectedPlan?.all_rider_amount
													) || 0
												)}`}
												</span>
											</div>
										</div>
									)}

									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50text-left">
											<span className="formatted-text">{`No Claim Discount (${parseFloat(
												selectedPlan?.ncd_percent || 0
											)}%)`}</span>
										</div>
										<div className="vw-50 text-right">
											<span className="fw-medium color-heading">{`- RM ${new Intl.NumberFormat(
												"en-US",
												{
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}
											).format(selectedPlan?.ncd_amount || 0)}`}</span>
										</div>
									</div>
								</div>

								{selectedPlan.extra_coverages && selectedPlan.extra_coverages.length > 0 && (
									<div className="col-lg-6 text-left px-20">
										<h4 className="my-2 mt-4">Add-Ons</h4>
											{selectedPlan.extra_coverages.map((add_ons, index) => (
												<div className="d-flex justify-content-between align-items-start pb-2">
													<div className="vw-50 col-sm-6 text-left">
														<span className="formatted-text">
															{add_ons.description
																? decodeURIComponent(add_ons.description)
																: getAddOnDescription(add_ons.code)}
														</span>
													</div>
													{(add_ons.amount && add_ons.amount != 0) ?
													<>
														<div className="vw-50 col-sm-6 text-right">
															<span className="fw-medium color-heading">
															{`RM ${new Intl.NumberFormat(
																'en-US',
																{
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
																}
															).format(add_ons?.amount)}`}
															</span>
														</div>
													</>
													:
													<>
													<div className="vw-50 col-sm-6 text-right">
														<span className="fw-medium color-heading">
														{`RM ${new Intl.NumberFormat(
															'en-US',
															{
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
															}
														).format(add_ons?.sum_insured)}`}
														</span>
													</div>
													</>
													}
												</div>
										))}

									</div>
								)}								

								<hr style={{ border: '1px solid #555', backgroundColor: '#555', width: 'calc(100% - 40px)' }} />

								<div className="col-lg-6 text-left px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className={`vw-50 text-left`}>
											<span className="fw-bold color-heading">
												Gross Contribution/Premium
											</span>
										</div>
										<div className={`vw-50 text-right`}>
											<span className="fw-bold color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.gross_premium || 0)}`}
											</span>
										</div>
									</div>
								</div>

								<div style={{ marginTop: '30px' }}></div>

								<div className="col-lg-6 text-left px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className={`vw-50 text-left`}>
											<span className="formatted-text">
												{`Service Tax (${parseFloat(selectedPlan?.sst_percent || 0)}%)`}
											</span>
										</div>
										<div className={`vw-50 text-right`}>
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.sst_premium || 0)}`}
											</span>
										</div>
									</div>
								</div>

								<div className="col-lg-6 text-left px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className={`vw-50 text-left`}>
											<span className="formatted-text">{`Stamp Duty`}</span>
										</div>
										<div className={`vw-50 text-right`}>
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.stamp_duty || 0)}`}
											</span>
										</div>
									</div>
								</div>


								{vehicleInfo?.insurer_name !== "ETIQA" && (
									<>
									<hr style={{ border: '1px solid #555', backgroundColor: '#555', width: 'calc(100% - 40px)', height: "1px" }} />
									<div className="col-lg-6 text-left px-20">
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div className={`vw-50 text-left`}>
												<span
													className="fw-bold color-heading"
													style={{ fontSize: "0.9rem" }}
												>
													{"Sub-Total"}
												</span>
											</div>
											<div className={`vw-50 text-right`}>
												<span
													className="fw-bold color-heading"
													style={{ fontSize: "0.9rem" }}
												>
													{`RM ${new Intl.NumberFormat("en-US", {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}).format(
														Number(selectedPlan?.sst_premium || 0) +
															Number(selectedPlan?.stamp_duty || 0)
													)}`}
												</span>
											</div>
										</div>
									</div>
									</>
								)}

								<div style={{ marginTop: '50px' }}></div>

								<div className="col-lg-6 text-left px-20">
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="vw-50 text-left">
										<span
											className="fw-bold color-heading"
											style={{ fontSize: '1.1rem' }} 
										>
												{"Total Payable Amount"}
											</span>
										</div>
										<div className="vw-50 text-right">
										<span
											className="fw-bold color-heading"
											style={{ fontSize: '1.1rem' }}
										>{`RM ${new Intl.NumberFormat(
												"en-US",
												{
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
										  		}
											).format(selectedPlan?.total_payable || 0
										  	)}`}</span>
										</div>
									</div>
								</div>

								<hr style={{ border: '1px solid #555', backgroundColor: '#555', width: 'calc(100% - 40px)' }} />

								<div className="col-lg-6 text-left mt-2 px-20">
									{vehicleInfo?.insurer_name === "GENERALI" && 
										<>
											<div className="d-flex justify-content-between align-items-center pb-2">
												<div className="text-left" style={{ width: "50%" }}>
													<span className="formatted-text">
														{`Voluntary Excess`}
													</span>
												</div>
												<div className="text-right" style={{ width: "50%" }}>
													<span className="fw-medium color-heading">
														{`RM ${new Intl.NumberFormat("en-US", {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(selectedPlan?.excess_amount || 0)}`}
													</span>
												</div>
											</div>
											<div className="d-flex justify-content-between align-items-center pb-2">
												<div className="text-left">
													<span className="formatted-text flex align-items-center gap-1">
														{`Compulsory Excess`}
														<MdInfoOutline
														onClick={(e)=> {
															setOpenCompulsoryExcessModal(true);
														}}
															className="dark"
														/>
													</span>
												</div>
												<div className="text-right">
													<span className="fw-medium color-heading">
														{`RM ${new Intl.NumberFormat("en-US", {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(selectedPlan?.comp_excess || 0)}`}
													</span>
												</div>
											</div>
										</>
									}
									{vehicleInfo?.insurer_name === "LONPAC" && (
										<div className="d-flex justify-content-between align-items-center pb-2">
											<div
												className="text-left"
												style={{ width: "50%" }}
											>
												<span className="formatted-text">
													{`Policy Excess`}
												</span>
											</div>
											<div
												className="text-right"
												style={{ width: "50%" }}
											>
												<span className="fw-medium color-heading">
													{`RM ${new Intl.NumberFormat("en-US", {
														minimumFractionDigits: 2,
														maximumFractionDigits: 2,
													}).format(selectedPlan?.excess_amount || 0)}`}
												</span>
											</div>
										</div>
									)}
									<div className="d-flex justify-content-between align-items-center pb-2">
										<div className="text-left" style={{ width: "50%" }}>
											<span className="formatted-text">
												{`Intermediaries’ Commission (${parseFloat(
													selectedPlan?.commission_percent || 0
												)}%)`}
											</span>
										</div>
										<div className="text-right" style={{ width: "50%" }}>
											<span className="fw-medium color-heading">
												{`RM ${new Intl.NumberFormat("en-US", {
													minimumFractionDigits: 2,
													maximumFractionDigits: 2,
												}).format(selectedPlan?.commission_amount || 0)}`}
											</span>
										</div>

										{/* Agreement Section */}
										<div
											className="mb-3"
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												justifyContent: "center",
												marginBottom: "0 !important",
											}}
										>
											<p
												style={{
													fontWeight: 600,
													fontSize: "16px",
													color: "#253858",
												}}
											>
												<span className="required-asterisk">*</span>
												{vehicleInfo?.insurer_name === "LIBERTY"
													? `Please ensure you have read, understood and accepted the terms and conditions before clicking the checkbox to proceed.`
													: ` Please read, understand, and accept the Terms and Conditions. Click on all hyperlinks below before proceeding.`}
											</p>
										</div>

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													inputId="agreementModal"
													name="agreementModal"
													value={checkModal}
													onChange={handleModalCheckboxChange}
													checked={checkModal}
												/>
												<span className="ml-2">
													{vehicleInfo?.insurer_name === "LONPAC" ? (
													<>
														I am aware that I have the option to purchase similar products that provide a rebate on 
														commission through Lonpac Insurance Bhd branches.
													</>
													) : (
													<>
														I acknowledge that Advance Fin Advisory Sdn Bhd will
														receive 10% commission for providing
														<a
															href="#"
															className="color-primary"
															onClick={(e) => {
																e.preventDefault();
																setIsModalVisible(true);
																setHasOpenedModal(true);
																// setCheckModal(true); // Ensure checkbox is checked when the link is clicked
															}}
														>
															{` takaful/insurance-related services `}
														</a>
														{vehicleInfo?.insurer_name === "TUNE PROTECT" ? 
															<>
																{`and by proceeding, consumers have an option to purchase similar product with a rebate on commission or is commission-free if purchased directly from TIMB's own website or physical branches.`}
															</> : <>
																{`and by proceeding, I will not be entitled to any ${vehicleInfo?.insurer_name === "GENERALI" ? "commission rebate." : "rebate."}`}
															</>
														}
														{vehicleInfo?.insurer_name !== "TUNE PROTECT" && 
														<div>
															{
																vehicleInfo?.insurer_name === "BERJAYA SOMPO" 
																	? `Please visit Berjaya Sompo Insurance's website or physical branches if you wish to purchase similar product that provides a rebate on commission or is commission-free.` 
																	: vehicleInfo?.insurer_name === "GENERALI" 
																	? `I also understand that I may consider exploring similar commission-free products directly from the corresponding insurer's website or physical branches.`
																	: `Please visit the selected Takaful/Insurance Company website if you wish to go direct.`
															}
														</div>
														}
													</>
													)}
												</span>
											</div>
										</div>

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													inputId="agreementProduct"
													name="agreementProduct"
													value={checkProduct}
													onChange={handleProductCheckboxChange}
													checked={checkProduct}
												/>
												<span className="ml-2">
													{vehicleInfo?.insurer_name === "GENERALI" ? 
													(
														<>
															{`I have read, understood and agreed to be bound by terms and conditions 
															stipulated in and Policy Wording of the policy. The Product Disclosure Sheet 
															is provided for reference only and shall not prevail over Policy Wording. 
															Where required, I have contacted Advance Fin Advisory Sdn Bhd or the corresponding 
															insurer directly for any terms that I do not understand prior to entering 
															into this contract.`}
														</>
													)
													:
													(
													<>
														I have read and understood the
														{vehicleInfo?.insurer_name === "BERJAYA SOMPO" || vehicleInfo?.insurer_name === "LIBERTY" ?
															<a
																href="https://www.ansa.my/wp-content/uploads/2025/07/AFA_SERVICE_GUIDE.pdf"
																className="color-primary"
																target="_blank"
																rel="noopener noreferrer"
															>
																{` Service Guide.`}
															</a>
															: ' Service Guide.'
														}
														{vehicleInfo?.insurer_name !== "LIBERTY" && (
														<>
															{vehicleInfo?.insurer_name === "ETIQA" ? (
																<>
																	I acknowledge that Advance Fin Advisory Sdn Bhd is an authorised agent for Etiqa General Insurance Berhad
																</>
															) : (
																<>
																	I acknowledge that Advance Fin Advisory Sdn Bhd is an authorised agent for the
																	<a
																		href="#"
																		className="color-primary"
																		onClick={(e) => {
																			e.preventDefault();
																			setIsProductsVisible(true);
																			setHasOpenedProducts(true);
																			// setCheckProduct(true); // Ensure checkbox is checked when the link is clicked
																		}}
																	>
																		{` insurance products.`}
																	</a>
																</>
															)}
														</>
														)}
													</>
													)}
												</span>
											</div>
										</div>
										<div className="mb-3">
											<div className="flex">
												<Checkbox
													inputId="agreementAck"
													name="agreementAck"
													value={checkAck}
													onChange={handleAckCheckboxChange}
													checked={checkAck}
												/>
												<span className="ml-2">
													<Acknowledgement
														insurer_name={vehicleInfo?.insurer_name}
														onClick={(e)=> {
															if (vehicleInfo?.insurer_name !== "LIBERTY" || vehicleInfo?.insurer_name !== "LONPAC") {
																e.preventDefault();
																setIsAckVisible(true);
																setHasOpenedAck(true);
															}
														}}/>
												</span>
											</div>
										</div>
										{vehicleInfo?.insurer_name === "TAKAFUL IKHLAS" &&
											<>
											<div className="mb-3">
												<div className="flex">
													<Checkbox
														inputId="agreementTakaful"
														name="agreementTakaful"
														value={checkTakaful}
														onChange={(e)=> {
															setCheckTakaful(prev => !prev);
														}}
														checked={checkTakaful}
													/>
													<span className="ml-2">
														I hereby confirm that I had read and agreed to the 
														{` `}
														<a
															href={takafulikhlasaqad}
															target="_blank"
															className="color-primary"
															rel="noopener noreferrer">
															Aqad 
														</a>
														{` `}
														and
														{` `}
														<a
															href={takafulikhlasPDP}
															target="_blank"
															className="color-primary"
															rel="noopener noreferrer">
															PDPA 
														</a>
														{` `}
														Terms and Condition
													</span>
												</div>
											</div>
											<div className="mb-3">
												<div className="flex">
													<Checkbox
														inputId="agreementTakafulMarketing"
														name="agreementTakafulMarketing"
														value={checkTakafulMarketing}
														onChange={(e)=> {
															setCheckTakafulMarketing(prev => !prev);
														}}
														checked={checkTakafulMarketing}
													/>
													<span className="ml-2">
														I expressly agree to receive
														{` `}
														<a
															href={takafulikhlasPDP}
															target="_blank"
															className="color-primary"
															rel="noopener noreferrer">
															Marketing Communication
														</a>
														{` `}
														from Takaful IKHLAS General Berhad
													</span>
												</div>
											</div>
											</>
										}

										

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													ref={checkConfirmAllRef}
													inputId="agreementAll"
													name="agreementAll"
													value={checkConfirmAll}
													onChange={(e)=> {
														if (checkConfirmAllRef.current) {
															checkConfirmAllRef.current.getElement().blur()
														}
														setCheckConfirmAll(e.target.checked)
														}}
													checked={checkConfirmAll}
												/>
												<span className="ml-2">
													I hereby confirm and verify that all the above information provided is true and accurate.
												</span>
											</div>
										</div>

										{openCompulsoryExcessModal && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Insurance related services`}
												visible={openCompulsoryExcessModal}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={()=> setOpenCompulsoryExcessModal(false)}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<h4 className="my-2">{`COMPULSORY EXCESS:`}</h4>
																	<span className="formatted-text">{`In addition to the Excess shown in the Schedule, we have the right to deduct another RM400 as Compulsory Excess if at the time of the incident, you or the person driving your car with your consent:`}</span>
																</div>
																<ul className="px-3">
																	<li className="color-heading">is under 21 years old: or</li>
																	<li className="color-heading">holds a Provisional (P) or Learner (L) driver’s licence; or</li>
																	<li className="color-heading">is not named in the Schedule as Named Driver.</li>
																</ul>
																<span className="formatted-text">We will not deduct this additional RM400 if the loss or damage is caused by fire, explosion, lightning, burglary, housebreaking, theft, third party property damage or bodily injury claims.</span>
															</div>
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<h4 className="my-2">{`EXCESS DAMAGE CLAIM:`}</h4>
																	<span className="formatted-text">Refers to the excess amount you have agreed to pay on the own damage claim as specified in your policy during the period of cover.</span>
																</div>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={hide}
														/>
													</>
												)}
											></Dialog>
										)}


										{/* Modals */}
										{isModalVisible && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Insurance related services`}
												visible={isModalVisible}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={closeFilterModal}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<h2 className="my-2">{`Takaful/Insurance related services`}</h2>
																	<span className="formatted-text">{`By purchasing the certificate/policy with Advance Fin Advisory Sdn Bhd the following takaful/insurance related services are also provided.`}</span>
																</div>
						
																<ul className="px-3">
																	<li className="color-heading">{`Assistance with claims and refunds`}</li>
																	<li className="color-heading">{`Additional advice on product information`}</li>
																	<li className="color-heading">{`Responses to queries and complaints`}</li>
																	<li className="color-heading">{`Help with checking and resolving NCD issues for motor policyholders/participants`}</li>
																	{vehicleInfo?.insurer_name === "BERJAYA SOMPO" &&
																		<li className="color-heading">{`For more information on the purchase and product information, claims matters or complaints, kindly contact us at customer@bsompo.com.my.`}</li>
																	}
																</ul>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={closeFilterModal}
														/>
													</>
												)}
											></Dialog>
										)}

										{isAckVisible && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Acknowledge`}
												visible={isAckVisible}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={closeAckModal}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<h2 className="my-2">{`Acknowledge`}</h2>
																	{vehicleInfo?.insurer_name === "GENERALI" &&
																		<p className="color-heading">{`I consent to the processing of my personal data by Advance Fin Advisory Sdn Bhd and the corresponding insurer.`}</p>
																	}
																	<span className="formatted-text">
																		{`By clicking the checkbox to proceed, I confirm that I have read and understood the relevant Product Disclosure Sheets, Certificate/Policy Wordings, and ${
																			vehicleInfo?.insurer_name === "GENERALI" ? "Data Privacy Policy/Notice" : "Privacy Policy"
																		}.`}
																	</span>
																</div>
						
																<p className="color-heading">{`I agree that the Company may collect, use, process, disclose, and store my personal data (including sensitive personal data) for takaful/insurance-related operations. This may include sharing my data with the Company’s related companies, subsidiaries, holding companies, outsourcing partners, reinsurers, solicitors, and affiliate companies, including their outsourcing partners.`}</p>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={closeAckModal}
														/>
													</>
												)}
											></Dialog>
										)}

										{isProductsVisible && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Advance Fin Advisory is the registered financial advisor all the takaful/insurance companies below.`}
												visible={isProductsVisible}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={closeProductsModal}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<span className="my-2">{`Advance Fin Advisory is the registered financial advisor all the takaful/insurance companies below.`}</span>
																	{/* First Row */}
																	<div className="d-flex justify-content-between align-items-center my-3">
																		<img
																			src={lonpacInsurance}
																			alt="Lonpac Insurance"
																			className="mx-2"
																			style={{ width: "100px", height: "auto" }}
																		/>
																		<img
																			src={etiqaInsurance}
																			alt="Etiqa Insurance"
																			className="mx-2"
																			style={{ width: "80px", height: "auto" }}
																		/>
																		<img
																			src={allianz}
																			alt="Allianz"
																			className="mx-2"
																			style={{ width: "80px", height: "auto" }}
																		/>
																	</div>
																	{/* Second Row */}
																	<div className="d-flex justify-content-between align-items-center my-3">
																		<img
																			src={generali}
																			alt="Generali"
																			className="mx-2"
																			style={{ width: "50px", height: "auto" }}
																		/>
																		<img
																			src={tokioMarine}
																			alt="Tokio Marine"
																			className="mx-2"
																			style={{ width: "auto", height: "30px" }}
																		/>
																		<img
																			src={rhbInsuracne}
																			alt="RHB Insurance"
																			className="mx-2"
																			style={{ width: "auto", height: "18px" }}
																		/>
																	</div>
																	{/* Third Row */}
																	<div className="d-flex justify-content-start align-items-center my-3">
																		<img
																			src={berjayaSompo}
																			alt="Berjaya Sompo"
																			className="mx-2"
																			style={{ width: "auto", height: "40px" }}
																		/>
																		<img
																			src={takafulIkhlas}
																			alt="Takaful Ikhlas"
																			className="mx-2"
																			style={{ width: "auto", height: "40px" }}
																		/>
																		<img
																			src={tuneInsurance}
																			alt="Tune Protect"
																			className="mx-2"
																			style={{ width: "auto", height: "40px" }}
																			/>
																			<img
																			src={liberty}
																			alt="Liberty"
																			className="mx-2"
																			style={{ width: "auto", height: "40px" }}
																			/>
																	</div>
																</div>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={closeProductsModal}
														/>
													</>
												)}
											></Dialog>
										)}

										<Button
											label="Proceed (5/5)"
											className="btn-primary mt-4"
											loading={loading}
											disabled={!checkAck || !checkModal || !checkProduct || !checkConfirmAll || (vehicleInfo?.insurer_name === "TAKAFUL IKHLAS" && !checkTakaful)}
											onClick={(e) => submitCarDetails(e)}
										/>

										{/* BottomMessagePopUp Component */}
										<BottomMessagePopUp
											message={errorMessage}
											type="error"
											isVisible={isErrorVisible}
											onClose={() => setIsErrorVisible(false)}
										/>
									</div>
								</div>
							</div>
						</div>

						{/*
						<div className="mb-3" 
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							marginBottom: '0 !important',
						}}>
							<p
								style={{
									fontWeight: 600,
									fontSize: '16px',
									color: '#253858',
								}}
							>
								<span className="required-asterisk">*</span>
								{ vehicleInfo?.insurer_name === "LIBERTY" ?
								`Please ensure you have read, understood and accepted the terms and conditions before clicking the checkbox to proceed.`
								:
								` Please read, understand, and accept the Terms and Conditions. Click on all hyperlinks below before proceeding.`}
							</p>
						</div>

							<div className="mb-3">
								<div className="flex">
									<Checkbox
										inputId="agreementModal"
										name="agreementModal"
										value={checkModal}
										onChange={handleModalCheckboxChange}
										checked={checkModal}
									/>
									<span className="ml-2">
										I acknowledge that Advance Fin Advisory Sdn Bhd will receive 10% commission for providing
										<a
											href="#"
											className="color-primary"
											onClick={(e) => {
												e.preventDefault();
												setIsModalVisible(true);
												setHasOpenedModal(true);
												// setCheckModal(true); // Ensure checkbox is checked when the link is clicked
											}}
										>
											<p
												style={{
													fontWeight: 600,
													fontSize: "16px",
													color: "#253858",
												}}
											>
												<span className="required-asterisk">*</span>
												{vehicleInfo?.insurer_name === "LIBERTY"
													? `Please ensure you have read, understood and accepted the terms and conditions before clicking the checkbox to proceed.`
													: ` Please read, understand, and accept the Terms and Conditions. Click on all hyperlinks below before proceeding.`}
											</p>
										</div>

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													inputId="agreementModal"
													name="agreementModal"
													value={checkModal}
													onChange={handleModalCheckboxChange}
													checked={checkModal}
												/>
												<span className="ml-2">
													{vehicleInfo?.insurer_name === "LONPAC" ? (
													<>
														I am aware that I have the option to purchase similar products that provide a rebate on 
														commission through Lonpac Insurance Bhd branches.
													</>
													) : (
													<>
														I acknowledge that Advance Fin Advisory Sdn Bhd will
														receive 10% commission for providing
														<a
															href="#"
															className="color-primary"
															onClick={(e) => {
																e.preventDefault();
																setIsModalVisible(true);
																setHasOpenedModal(true);
																// setCheckModal(true); // Ensure checkbox is checked when the link is clicked
															}}
														>
															{` insurance-related services `}
														</a>
														{`and by proceeding, I will not be entitled to any ${vehicleInfo?.insurer_name === "GENERALI" ? "commission rebate." : "rebate."}`}
														<div>
															{
																vehicleInfo?.insurer_name === "BERJAYA SOMPO" 
																	? `Please visit Berjaya Sompo Insurance's website or physical branches if you wish to purchase similar product that provides a rebate on commission or is commission-free.` 
																	: vehicleInfo?.insurer_name === "GENERALI" 
																	? `I also understand that I may consider exploring similar commission-free products directly from the corresponding insurer's website or physical branches.`
																	: vehicleInfo?.insurer_name === "TUNE PROTECT"
																	? `Consumers have an option to purchase similar product with a rebate on commission or is commission-free if purchased directly from TIMB's own website or physical branches.`
																	: `Please visit the selected Insurance Company website if you wish to go direct.`
															}
														</div>
													</>
													)}
												</span>
											</div>
										</div>

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													inputId="agreementProduct"
													name="agreementProduct"
													value={checkProduct}
													onChange={handleProductCheckboxChange}
													checked={checkProduct}
												/>
												<span className="ml-2">
													{vehicleInfo?.insurer_name === "GENERALI" ? 
													(
														<>
															{`I have read, understood and agreed to be bound by terms and conditions 
															stipulated in and Policy Wording of the policy. The Product Disclosure Sheet 
															is provided for reference only and shall not prevail over Policy Wording. 
															Where required, I have contacted Advance Fin Advisory Sdn Bhd or the corresponding 
															insurer directly for any terms that I do not understand prior to entering 
															into this contract.`}
														</>
													)
													:
													(
													<>
														I have read and understood the
														{vehicleInfo?.insurer_name === "BERJAYA SOMPO" || vehicleInfo?.insurer_name === "LIBERTY" ?
															<a
																href="https://www.ansa.my/wp-content/uploads/2025/07/AFA_SERVICE_GUIDE.pdf"
																className="color-primary"
																target="_blank"
																rel="noopener noreferrer"
															>
																{` Service Guide.`}
															</a>
															: ' Service Guide.'
														}
														{vehicleInfo?.insurer_name !== "LIBERTY" && (
														<>
															I acknowledge that Advance Fin Advisory Sdn Bhd is an authorised agent for the
															<a
																href="#"
																className="color-primary"
																onClick={(e) => {
																	e.preventDefault();
																	setIsProductsVisible(true);
																	setHasOpenedProducts(true);
																	// setCheckProduct(true); // Ensure checkbox is checked when the link is clicked
																}}
															>
																{` insurance products.`}
															</a>
														</>
														)}
													</>
													)}
												</span>
											</div>
										</div>

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													inputId="agreementAck"
													name="agreementAck"
													value={checkAck}
													onChange={handleAckCheckboxChange}
													checked={checkAck}
												/>
												<span className="ml-2">
													{vehicleInfo?.insurer_name === "LIBERTY" 
														? `I hereby acknowledge the commission entitled by "Advance Fin Advisory Sdn Bhd" for my purchase of Insurance product(s) and that I have read and agreed to the`
														: vehicleInfo?.insurer_name === "LONPAC"
														? `I agree to the`
														: `I acknowledge and accept that Advance Fin Advisory Sdn Bhd will receive a commission for my purchase of insurance product(s), and I agree to the`
													}
													<a
														href={vehicleInfo?.insurer_name === "LIBERTY" ? "https://www.ansa.my/wp-content/uploads/2025/09/ANSA_DIGITAL_Terms_and_Conditions.pdf" : "#"}
														target="_blank"
														className="color-primary"
														rel="noopener noreferrer"
														onClick={(e) => {
															if (vehicleInfo?.insurer_name !== "LIBERTY" || vehicleInfo?.insurer_name !== "LONPAC") {
																e.preventDefault();
																setIsAckVisible(true);
																setHasOpenedAck(true);
															}
															// setCheckAck(true); // Ensure checkbox is checked when the link is clicked
														}}
													>
														{` Terms and Conditions`}
													</a>
													{vehicleInfo?.insurer_name === "LIBERTY" ?
														<>
															<span>{` and `}</span>
															<a
																href="https://www.liberty.my/images/PrivacyNotice.pdf"
																className="color-primary"
																target="_blank"
																rel="noopener noreferrer"
															>
																{`Privacy Notice`}
															</a>
														</>
														:
														vehicleInfo?.insurer_name === "LONPAC" ?
														<>
															<span>{` of this platform`}</span>
														</>
														:
														<></>
													}
													.
												</span>
											</div>
										</div>

										<div className="mb-3">
											<div className="flex">
												<Checkbox
													ref={checkConfirmAllRef}
													inputId="agreementAll"
													name="agreementAll"
													value={checkConfirmAll}
													onChange={(e)=> {
														if (checkConfirmAllRef.current) {
															checkConfirmAllRef.current.getElement().blur()
														}
														setCheckConfirmAll(e.target.checked)
														}}
													checked={checkConfirmAll}
												/>
												<span className="ml-2">
													I hereby confirm and verify that all the above information provided is true and accurate.
												</span>
											</div>
										</div>

										{isModalVisible && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Insurance related services`}
												visible={isModalVisible}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={closeFilterModal}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<h2 className="my-2">{`Insurance related services`}</h2>
																	<span className="formatted-text">{`By purchasing the policy with Advance Fin Advisory Sdn Bhd the following insurance related services are also provided.`}</span>
																</div>
						
																<ul className="px-3">
																	<li className="color-heading">{`Assistance with claims and refunds`}</li>
																	<li className="color-heading">{`Additional advice on product information`}</li>
																	<li className="color-heading">{`Responses to queries and complaints`}</li>
																	<li className="color-heading">{`Help with checking and resolving NCD issues for motor policyholders`}</li>
																	{vehicleInfo?.insurer_name === "BERJAYA SOMPO" &&
																		<li className="color-heading">{`For more information on the purchase and product information, claims matters or complaints, kindly contact us at customer@bsompo.com.my.`}</li>
																	}
																</ul>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={closeFilterModal}
														/>
													</>
												)}
											></Dialog>
										)}

										{isAckVisible && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Acknowledge`}
												visible={isAckVisible}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={closeAckModal}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<h2 className="my-2">{`Acknowledge`}</h2>
																	{vehicleInfo?.insurer_name === "GENERALI" &&
																		<p className="color-heading">{`I consent to the processing of my personal data by Advance Fin Advisory Sdn Bhd and the corresponding insurer.`}</p>
																	}
																	<span className="formatted-text">
																		{`By clicking the checkbox to proceed, I confirm that I have read and understood the relevant Product Disclosure Sheets, Policy Wordings, and ${
																			vehicleInfo?.insurer_name === "GENERALI" ? "Data Privacy Policy/Notice" : "Privacy Policy"
																		}.`}
																	</span>
																</div>
						
																<p className="color-heading">{`I agree that the Company may collect, use, process, disclose, and store my personal data (including sensitive personal data) for insurance-related operations. This may include sharing my data with the Company’s related companies, subsidiaries, holding companies, outsourcing partners, reinsurers, solicitors, and affiliate companies, including their outsourcing partners.`}</p>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={closeAckModal}
														/>
													</>
												)}
											></Dialog>
										)}

										{isProductsVisible && (
											<Dialog
												className="filter-modal d-flex flex-row bg-white p-20 gap-2"
												modal
												header={`Advance Fin Advisory is the registered financial advisor all the insurance companies below.`}
												visible={isProductsVisible}
												style={{
													borderRadius: "24px",
													margin: 0,
													width: "90%",
													overflowY: "auto",
												}}
												position={"center"}
												onHide={closeProductsModal}
												content={({ hide }) => (
													<>
														<div className="filters w-100">
															<div className="d-flex justify-content-between mb-2">
																<div>
																	<span className="my-2">{`Advance Fin Advisory is the registered financial advisor all the insurance companies below.`}</span>
												
																	<div className="d-flex justify-content-between align-items-center my-3">
																		<img
																			src={lonpacInsurance}
																			alt="Lonpac Insurance"
																			className="mx-2"
																			style={{ width: "100px", height: "auto" }}
																		/>
																		<img
																			src={etiqaInsurance}
																			alt="Etiqa Insurance"
																			className="mx-2"
																			style={{ width: "80px", height: "auto" }}
																		/>
																		<img
																			src={allianz}
																			alt="Allianz"
																			className="mx-2"
																			style={{ width: "80px", height: "auto" }}
																		/>
																	</div>
																	
																	<div className="d-flex justify-content-between align-items-center my-3">
																		<img
																			src={generali}
																			alt="Generali"
																			className="mx-2"
																			style={{ width: "50px", height: "auto" }}
																		/>
																		<img
																			src={tokioMarine}
																			alt="Tokio Marine"
																			className="mx-2"
																			style={{ width: "auto", height: "30px" }}
																		/>
																		<img
																			src={rhbInsuracne}
																			alt="RHB Insurance"
																			className="mx-2"
																			style={{ width: "auto", height: "18px" }}
																		/>
																	</div>
																	
																	<div className="d-flex justify-content-start align-items-center my-3">
																		<img
																			src={berjayaSompo}
																			alt="Berjaya Sompo"
																			className="mx-2"
																			style={{ width: "auto", height: "60px" }}
																		/>
																		<img
																			src={takafulIkhlas}
																			alt="Takaful Ikhlas"
																			className="mx-2"
																			style={{ width: "auto", height: "60px" }}
																		/>
																	</div>
																</div>
															</div>
														</div>
														<Button
															className="btn-primary"
															label="Okay"
															onClick={closeProductsModal}
														/>
													</>
												)}
											></Dialog>
										)}


							{isModalVisible && (
							<Dialog
								className="filter-modal d-flex flex-row bg-white p-20 gap-2"
								modal
								header={`Insurance related services`}
								visible={isModalVisible}
								style={{
									borderRadius: "24px",
									margin: 0,
									width: "90%",
									overflowY: "auto",
								}}
								position={"center"}
								onHide={closeFilterModal}
								content={({ hide }) => (
									<>
										<div className="filters w-100">
											<div className="d-flex justify-content-between mb-2">
												<div>
													<h2 className="my-2">{`Insurance related services`}</h2>
													<span className="formatted-text">{`By purchasing the policy with Advance Fin Advisory Sdn Bhd the following insurance related services are also provided.`}</span>
												</div>
		
												<ul className="px-3">
													<li className="color-heading">{`Assistance with claims and refunds`}</li>
													<li className="color-heading">{`Additional advice on product information`}</li>
													<li className="color-heading">{`Responses to queries and complaints`}</li>
													<li className="color-heading">{`Help with checking and resolving NCD issues for motor policyholders`}</li>
													{vehicleInfo?.insurer_name === "BERJAYA SOMPO" &&
														<li className="color-heading">{`For more information on the purchase and product information, claims matters or complaints, kindly contact us at customer@bsompo.com.my.`}</li>
													}
												</ul>
											</div>
										</div>
										<Button
											label="Proceed (5/5)"
											className="btn-primary mt-4"
											loading={loading}
											disabled={!checkAck || !checkModal || !checkProduct || !checkConfirmAll}
											onClick={(e) => submitCarDetails(e)}
										/>

										<BottomMessagePopUp
											message={errorMessage}
											type="error"
											isVisible={isErrorVisible}
											onClose={() => setIsErrorVisible(false)}
										/>
									</>
								)}
							></Dialog>
							)}

							{isProductsVisible && (
							<Dialog
							className="filter-modal d-flex flex-row bg-white p-20 gap-2"
							modal
							header={`Advance Fin Advisory is the registered financial advisor all the insurance companies below.`}
							visible={isProductsVisible}
							style={{
								borderRadius: "24px",
								margin: 0,
								width: "90%",
								overflowY: "auto",
							}}
							position={"center"}
							onHide={closeProductsModal}
							content={({ hide }) => (
								<>
									<div className="filters w-100">
										<div className="d-flex justify-content-between mb-2">
											<div>
												<span className="my-2">{`Advance Fin Advisory is the registered financial advisor all the insurance companies below.`}</span>

												<div className="d-flex justify-content-between align-items-center my-3">
													<img
														src={lonpacInsurance}
														alt="Lonpac Insurance"
														className="mx-2"
														style={{ width: "100px", height: "25px" }}
													/>
													<img
														src={etiqaInsurance}
														alt="Etiqa Insurance"
														className="mx-2"
														style={{ width: "50px", height: "20px" }}
													/>
													<img
														src={allianz}
														alt="Allianz"
														className="mx-2"
														style={{ width: "80px", height: "auto" }}
													/>
												</div>

												<div className="d-flex justify-content-between align-items-center my-3">
													<img
														src={generali}
														alt="Generali"
														className="mx-2"
														style={{ width: "50px", height: "auto" }}
													/>
													<img
														src={tokioMarine}
														alt="Tokio Marine"
														className="mx-2"
														style={{ width: "auto", height: "30px" }}
													/>
													<img
														src={rhbInsuracne}
														alt="RHB Insurance"
														className="mx-2"
														style={{ width: "auto", height: "18px" }}
													/>
												</div>

												<div className="d-flex justify-content-start align-items-center my-3">
													<img
														src={berjayaSompo}
														alt="Berjaya Sompo"
														className="mx-2"
														style={{ width: "auto", height: "60px" }}
													/>
													<img
														src={takafulIkhlas}
														alt="Takaful Ikhlas"
														className="mx-2"
														style={{ width: "auto", height: "60px" }}
													/>
												</div>
											</div>
										</div>
									</div>
									<Button
										className="btn-primary"
										label="Okay"
										onClick={closeProductsModal}
									/>
								</>
							)}
						></Dialog>
						)}

						<Button
							label="Proceed (5/5)"
							className="btn-primary mt-4"
							loading={loading}
							disabled={!checkAck || !checkModal || !checkProduct || !checkConfirmAll}
							onClick={(e) => submitCarDetails(e)}
						/>

						<BottomMessagePopUp
							message={errorMessage}
							type="error"
							isVisible={isErrorVisible}
							onClose={() => setIsErrorVisible(false)}
						/>
						*/}
					</div>
				</div>
			</div>
		</>
	);
};

export default CarDetails;
